import React, { Fragment } from 'react'
import yn from 'yn'
import getGetOrdinalSuffix from '../../../../utilities/content/getOrdinalSuffix'

const BkFlowEditGuestFieldTitle = props => {
	const {
		hotelLabels,
		guestGroup,
		removeGuestEvent
	} = props

	let baseClassNames = 'bk-flow-edit-guest__entry-title u-txt-center u-flex u-flex--justify-center'

	if (process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_LAYOUT === 'select') {
		baseClassNames = 'bk-flow-edit-guest__entry-title select'
	}

	const displayRoomNumber = !(process.env.REACT_APP_COMPONENT_EDIT_STAY_HIDE_ROOM_INDEXES
		&& yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_HIDE_ROOM_INDEXES))

	return (
		<div className={ baseClassNames }>
			{ process.env.REACT_APP_COMPONENT_EDIT_STAY_GUEST_LAYOUT === 'select' ?
				<p className="u-remove-margin u-font-small u-font-bold">
					{displayRoomNumber && (
						<Fragment>
							{ Number(guestGroup) > 0 && getGetOrdinalSuffix(Number(guestGroup) + 1) + ' ' }
						</Fragment>
					)}
					{ Number(guestGroup) > 0 ? hotelLabels.room ? hotelLabels.room + ' ' : 'Room ' : null }
					{ hotelLabels.guests ? hotelLabels.guests : 'Guests'}
				</p>
			:
				<Fragment>
					{ Number(guestGroup) > 0 &&
						<span className="bk-flow-edit-guest__entry-room-number u-font-xs">
							{displayRoomNumber && (
								<Fragment>
									{ getGetOrdinalSuffix(Number(guestGroup) + 1) }&nbsp;
								</Fragment>
							)}
							{ hotelLabels.room ? hotelLabels.room : 'Room' }
						</span>
					}
					<span className="u-font-small u-font-bold">{ hotelLabels.guests ? hotelLabels.guests : 'Guests'}</span>
				</Fragment>
			}

			{ removeGuestEvent &&
				Number(guestGroup) > 0 &&
					<button
						className="bk-flow-edit-guest__entry-remove u-font-xs"
						onClick={ () => removeGuestEvent(guestGroup) }
					>
						{ hotelLabels.remove ? hotelLabels.remove : 'Remove' } &times;
					</button>
			}
		</div>
	)
}

export default BkFlowEditGuestFieldTitle



// WEBPACK FOOTER //
// ./src/components/edit/guest/elements/BkFlowEditGuestFieldTitle.js